export const types = {
    FETCH_REQUEST: 'STATISTICS_OFFERS_FETCH_REQUEST',
    FETCH_SUCCESS: 'STATISTICS_OFFERS_FETCH_SUCCESS',
    FETCH_FAILURE: 'STATISTICS_OFFERS__FETCH_FAILURE',
}